import React, { useEffect } from 'react';
import { useDispatch } from 'redux-react-hook';
import styled from 'styled-components';
import _isObject from 'lodash/isObject';
import _get from 'lodash/get';
import { clearSessionTimeout } from 'redux/actions/session';
import { getLastQuestion } from 'redux/actions/consultation/question';
import { H1 } from 'styles/elements/headers';
import { Text } from 'styles/elements/text';
import { ColumnDiv } from 'styles/elements/div';
import { NextButton as RetryButton } from 'components/consultation/answers/nextButton';
import media from 'styles/media';
import { STRINGS } from 'config';

const ErrorContainer = styled(ColumnDiv)`
  position: ${media.IE9 ? 'relative' : 'absolute'};
  width: 100%;
  box-sizing: border-box;
  padding: 30px 12%;
  ${media.smallAndBelow`
    padding: 10px 3.5%;
    width: 100%;
  `}
`;

const ErrorDetails = styled.pre`
  white-space: normal;
  word-break: break-word;
`;

const Header = styled(H1)`
  margin-bottom: 25px;
  margin-top: 35px;
`;

export function Error({ error, isClinicalReviewMode }) {
  const isConnectivityError = _isObject(error) && !error.status && !error.errorMessage && !error.errorCode;
  const isOutOfHours = _isObject(error) && _get(error, 'response.body.errorCode', '') === STRINGS.SERVICE_ERROR_CODE.OUT_OF_HOURS;
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(clearSessionTimeout());
  }, [dispatch]);
  if (isOutOfHours && typeof error.response !== 'undefined') {
    return (
      <ErrorContainer ie9Height={600}>
        <ColumnDiv>
          <Header>Your practice is closed right now and not accepting online consultations.</Header>
          <Text dangerouslySetInnerHTML={{ __html: error.response.body.errorMessage }} />
        </ColumnDiv>
      </ErrorContainer>
    );
  }
  return (
    <ErrorContainer ie9Height={600}>
      {isConnectivityError ? (
        <ColumnDiv>
          <Header>It looks like there&apos;s a problem with your connection</Header>
          <Text>Check your internet connection or try again</Text>
          <RetryButton loadingText={['Please wait...', 'Trying to connect...']} onClick={() => dispatch(getLastQuestion())}>Try again</RetryButton>
        </ColumnDiv>
      ) : (
        <ColumnDiv>
          <Header>
            We&apos;re sorry, we are unable to process your consultation.
          </Header>
          <br />
          <h2>WE ARE WORKING TO RECTIFY THIS PROBLEM AS SOON AS POSSIBLE.</h2>
          {isClinicalReviewMode && <ErrorDetails>{_isObject(error) ? JSON.stringify(error) : error}</ErrorDetails>}
        </ColumnDiv>
      )}
    </ErrorContainer>
  );
}
